export enum SettingsSectionsName {
    FailedAttemptsPassword = "FailedAttemptsPassword",
    UserPasswordSettings = "UserPasswordSettings",
    UserSessionSettings = "UserSessionSettings",
    MaintenanceSettings = "MaintenanceSettings",
    ProjectSettings = "ProjectSettings",
    LoadingTimeSettings = "LoadingTimeSettings",
    RegistrationSettings = "RegistrationSettings",
    UserLoginSettings = "UserLoginSettings",
    SessionTimeSettings = "SessionTimeSettings",
    FeedbackSettings = "FeedbackSettings",
    GoogleSsoSettings = "GoogleSsoSettings",
    FacebookSsoSettings = "FacebookSsoSettings",
    LinkedInSsoSettings = "LinkedInSsoSettings",
    RuntimeEditorSettings = "RuntimeEditorSettings",
    PwaSettings = "PwaSettings",
    ReCaptchaSettings = "ReCaptchaSettings",
    TwoFactorSettings = "TwoFactorSettings",
    RavenApiSettings = "RavenApiSettings",
    PatientSettings = "PatientSettings",
    SnomedSettings = "SnomedSettings",
    FormioSettings = "FormioSettings",
    IM1ApiSettings = "IM1ApiSettings",
    DocumentSettings = "DocumentSettings",
    AlternateSiteInformationSettings = "AlternateSiteInformationSettings"
}
